export const compare = (a: any, b: any, attr: string) => {
  if (a[attr] < b[attr]) {
    return -1;
  }
  if (a[attr] > b[attr]) {
    return 1;
  }
  return 0;
};
